// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { Container } from '@crehana/ui';
import Loadable from '@crehana/web/Loadable';

import DashboardErrorView from '@/views/UserDashboard/components/DashboardTemplate/DashboardErrorView';

import CollapsedListSkeleton from '../../components/CollapsedListSkeleton';

const LazyTracks = () => (
  <Loadable
    Loader={
      <Container type="dashboard">
        <CollapsedListSkeleton />
      </Container>
    }
    ErrorFallback={
      <Container type="dashboard">
        <DashboardErrorView defaultConnectionError supportsDarkMode />
      </Container>
    }
    module={() =>
      import(/* webpackChunkName: "user-dashboard-tracks" */ './Tracks')
    }
  />
);
export default LazyTracks;
